module.exports = __webpack_public_path__ + "media/images/symbols/cuk-logo-5efb0309fdacf9d87ab6424fcb52ae75.png";